var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2698_127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1446 -2.94909e-05C21.5215 -0.0787795 -0.0785353 21.5212 0.00021465 48.1443C0.0770897 74.4656 22.0333 96 48.3565 96H96.0002V48.3562C96.0002 22.0331 74.4658 0.0768455 48.1446 -2.94909e-05ZM52.2696 72.4444C51.0196 73.5543 49.4571 74.11 47.5821 74.1112C45.7071 74.1125 44.1446 73.5568 42.8946 72.4444C41.6446 71.3331 41.0196 69.9112 41.0196 68.1787C41.0196 66.4462 41.6446 65.025 42.8946 63.915C44.1446 62.805 45.7071 62.2493 47.5821 62.2481C49.4571 62.2468 51.0196 62.8025 52.2696 63.915C53.5196 65.0262 54.1446 66.4475 54.1446 68.1787C54.1446 69.91 53.5177 71.3318 52.264 72.4444H52.2696ZM63.3752 41.0868C62.6027 42.6793 61.3627 44.3043 59.6552 45.9618L55.6202 49.7118C54.4727 50.8131 53.6771 51.9418 53.2333 53.0981C52.7896 54.2543 52.5452 55.725 52.5002 57.51H42.4558C42.4558 54.095 42.8415 51.3987 43.6127 49.4212C44.4051 47.4164 45.6958 45.6469 47.3627 44.28C49.094 42.8312 50.4102 41.5037 51.3115 40.2975C52.1901 39.1554 52.665 37.754 52.6615 36.3131C52.6615 32.7806 51.1408 31.0143 48.0996 31.0143C47.4519 30.9939 46.8081 31.1225 46.218 31.3904C45.628 31.6583 45.1074 32.0582 44.6965 32.5593C43.8302 33.5881 43.374 34.98 43.3277 36.735H31.4702C31.5177 32.055 32.9921 28.4106 35.8933 25.8018C38.7946 23.1931 42.8652 21.8887 48.1052 21.8887C53.3227 21.8887 57.3646 23.0937 60.2308 25.5037C63.0971 27.9137 64.5302 31.3418 64.5302 35.7881C64.5555 37.6194 64.1603 39.4322 63.3752 41.0868Z",
    fill: "url(#paint0_linear_2698_127)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2698_127",
    x1: 14.059,
    y1: 14.0587,
    x2: 96.0002,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#549EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DB0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2698_127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.c960babe3e8cd375b3438d0f7e52dbcb.svg";
export { ForwardRef as ReactComponent };